// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-sticky{position:fixed;width:100%;left:0;right:0;z-index:99;display:none}.banner-sticky .banner__wrapper{margin:0 auto}.banner-sticky.bottom{bottom:0}.banner-sticky.top{top:66px}.banner-sticky.top .banner__overlay-for-sticky{display:block;position:absolute;top:-11px;left:0;right:0;width:100%;height:12px;background:#fff}.banner-sticky.unit__outer-wrapper{margin:0;background:rgba(0,0,0,.6)}@media (max-width:767px){.banner-sticky{display:block}}", ""]);
// Exports
module.exports = exports;
